<template>
	<div class="footer-email-signup">
		<div :class="[validationClass]">
			<img
				v-once
				:src="logoUrl"
				class="footer-email-signup__image"
				alt="Blain's Farm &amp; Fleet Logo"
				loading="lazy"
				width="285"
				height="50"
			/>
			<p class="footer-email-signup__p">Be the first to hear about our sales, events, and promotions!</p>
			<form class="flex" @submit.prevent="submitEmail">
				<label :for="emailFieldId" class="hide-aria">
					Email Address
				</label>
				<input
					ref="_email"
					class="footer-email-signup__input flex-adapt"
					v-model.trim="email"
					type="text"
					placeholder="Enter your email"
					name="email"
					:id="emailFieldId"
				/>
				<b-button-submit-button
					class="footer-email-signup__button"
					color="blue"
					minimal
					aria-label="Sign Up for newsletter"
					:id="emailSubmitButtonId"
				>
					<i v-if="loading" class="fa fa-spinner fa-spin"></i>
					{{ loading ? '' : 'Sign Up' }}
				</b-button-submit-button>
			</form>
		</div>
		<div class="footer-divider"></div>
		<div class="footer-email-signup__socials-wrapper">
			<social-icons
				icon-size="md"
				icon-color="black"
				class="flex-row flex-between"
			/>
		</div>
		<slot></slot>
		<signup-modal-success
			v-if="showSuccessModal"
			@cancel="closeModal"
			:loading="loading"
		/>
	</div>
</template>

<script>
import BButtonSubmitButton from 'JS/components/blain-form/BButtonSubmitButton.vue';
import EmailSubscriptionService from '../../../services/EmailSubscriptionService.ts';
import SignupModalSuccess from './SignupModalSuccess.vue';
import SocialIcons from '../../../components/SocialIcons.vue';
import { validateEmail } from '../../../helpers/functions.js';

const emailService = new EmailSubscriptionService();

export default {
	name: 'SignUpSection',
	props: {
		logoSize: {
			type: String,
			default: 'md'
		},
		idPrefix: {
			type: String,
			required: true
		}
	},
	components: {
		SocialIcons,
		SignupModalSuccess,
		BButtonSubmitButton,
	},
	computed: {
		logoUrl() {
			return '/assets/images/logos/blain-horizontal.png';
		},
		isEmailValid() {
			return validateEmail(this.email);
		},
		validationClass() {
			if (this.showValidationIcon) {
				return this.isEmailValid ? 'valid' : 'invalid';
			} else {
				return '';
			}
		},
		emailFieldId() {
			return this.idPrefix + 'SignUpSectionEmailInput';
		},
		emailSubmitButtonId() {
			return this.idPrefix + 'SignUpSectionSubmitButton';
		},
	},
	data() {
		return {
			showValidationIcon: false,
			loading: false,
			email: null,
			showSuccessModal: false
		};
	},
	methods: {
		async submitEmail() {
			if (!this.email) return this.$refs._email.focus();
			this.showValidationIcon = true;
			if (!this.isEmailValid) {
				this.handleSignupFailure();
				return;
			}
			const result = await emailService.subscribeEmailToMarketing(this.email);
			if (!result.success) {
				this.handleSignupFailure();
				return;
			}
			this.loading = this.showSuccessModal = true;
			this.handleSignupSuccess();
		},
		handleSignupSuccess() {
			this.email = null;
			blainGtmDataLayer.push({
				'subscribeMethod': 'Footer',
				'event': "email_subscribe"
			});
			this.showValidationIcon = this.loading = false;
		},
		handleSignupFailure() {
			this.loading = false;
		},
		closeModal() {
			this.showSuccessModal = false;
		}
	},
};
</script>

<style lang='less'>
@import '../../../../less/_mixins.less';
.footer-email-signup {

	&__image {
		max-width: 100%;
	}

	&__p {
		font-size: 1rem;
		line-height: 1.5;
		color: #000000DE;
	}

	&__input {
		border: solid 1px #CBD0E4;
		border-radius: 6px 0 0 6px;
		color: #656E96;
		padding: 7px;
		font-size: 16px;
	}

	.footer-divider {
		margin: 20px 0;
	}

	&__button {
		right: 3px;
		text-wrap: nowrap;
	}

	&__socials-wrapper {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;

		.tablet-and-up-styles({
			justify-content: start;
		})
	}
}
</style>